import React from 'react';
import { addTranslationKeys } from 'Src/i18n';
import { ICONS } from 'Components/utils/icon/icons';
import { AccessAndMap } from 'Components/widgets/access-and-map/AccessAndMap';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
const ICON_MAPPING = {
  TRAIN_STATION: ICONS.TRAIN,
  AIRPORT: ICONS.TRANSPORT,
  PORT: ICONS.BOAT,
};
type Props = {
  accessTitle: string;
  config: CMSContent;
  hours: string;
  mapType: 'GOOGLE' | 'BAIDU';
  minutes: string;
  resort: Product;
  title?: string;
};

const buildAccess = (hours, minutes) => {
  return ({ name, transfertDurationMin, type }) => {
    return type
      ? {
          iconName: ICON_MAPPING[type.toUpperCase()],
          texts: [
            name,
            transfertDurationMin
              ? transfertDurationConverter(transfertDurationMin, hours, minutes)
              : null,
          ].filter(Boolean),
        }
      : null;
  };
};

/**
 * Convert transfertDuration format
 * @param {number} transfertDuration The duration to format
 * @param {string} hours Value from content
 * @param {string} minutes Value from content
 * @returns {string} The duration formatted
 */
const transfertDurationConverter = (transfertDuration, hours, minutes) => {
  const hoursValue = Math.floor(transfertDuration / 60);
  const minutesDuration = transfertDuration - hoursValue * 60;
  const minutesValue = minutesDuration > 0 ? `${minutesDuration} ${minutes}` : '';
  return hoursValue ? `${hoursValue}${hours}${minutesValue}` : minutesValue;
};

const sortAccessByDuration = (accessesA, accessesB) =>
  accessesA.transfertDurationMin && accessesB.transfertDurationMin
    ? accessesA.transfertDurationMin - accessesB.transfertDurationMin
    : 0;

export const ProductAccessAndMapLine = (props: Props) => {
  const { accessTitle, config, hours, mapType, minutes, resort = {}, title } = props;
  const accessesFiltered = resort.accesses
    .filter((access) => access.id && !access.id.includes('MICE'))
    .sort(sortAccessByDuration);
  addTranslationKeys(config);
  return (
    <SiteContainer className="Line">
      <LineTitle>{title}</LineTitle>
      <AccessAndMap
        accessTitle={accessTitle}
        access={[]
          .concat(accessesFiltered || [])
          .map(buildAccess(hours, minutes))
          .filter(Boolean)}
        address={resort.address}
        isBaidu={mapType === 'BAIDU'}
        map={resort.coordinates}
        productId={resort.id}
        productName={resort.name}
        streetView={resort.streetView}
      />
    </SiteContainer>
  );
};
